import { Component, HostBinding, HostListener, Input, ViewEncapsulation } from "@angular/core"
import { ModalRef } from "./modal-ref"

@Component({
    selector: "app-modal-backdrop",
    template: ``,
    encapsulation: ViewEncapsulation.None,
})
export class ModalBackdropComponent {
    public activeModal: ModalRef
    public clickOutsideToClose: boolean
    @HostBinding("style") styleBinding = "z-index: 1050"
    @HostBinding("class") get classBinding() {
        return `modal-backdrop show ${this.backdropClass ? this.backdropClass : ""}`
    }

    @HostListener("click", ["$event"])
    private onClick() {
        if (this.clickOutsideToClose && this.activeModal) {
            this.activeModal.dismiss()
        }
    }

    // TODO: backdropClass needs implementing
    @Input() backdropClass: string
}
